import { Col, Row, Form } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import React from 'react';
import { PHONE_OPTIONS } from './form/helper';
import Button from 'shared/button';
import { faPlus, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { databaseContactWarning } from './shared';
import { parsePhoneNumber } from 'helpers/formatters/phone_number_parser';
import advancedFormatPhoneNumber from 'helpers/formatters/advanced_phone_number_formats';

export default function PersonContactForm({
  accessibleDatabaseContacts = [],
  areFieldsRequired,
  displayName,
  person,
  showCompanyName = true,
  onAddPhoneNumber,
  onChangePhoneNumberPrimary,
  onDeletePhoneNumber,
  onFieldChange,
  onPhoneNumberChange
}) {
  return (
    <React.Fragment>
      {databaseContactWarning(accessibleDatabaseContacts, displayName)}
      <Row>
        <Col sm={6}>
          <Form.Group className="form-group">
            <Form.Label>
              First Name {areFieldsRequired && (<span className="text-danger">(Required)</span>)}
            </Form.Label>
            <input
              className="form-control"
              placeholder="Enter first name"
              type="text"
              value={person.firstName || ''}
              onChange={e => onFieldChange(e.target.value, 'firstName')}
            />
          </Form.Group>
        </Col>

        <Col sm={6}>
          <Form.Group className="form-group">
            <Form.Label>
              Last Name {areFieldsRequired && (<span className="text-danger">(Required)</span>)}
            </Form.Label>
            <input
              className="form-control"
              placeholder="Enter last name"
              type="text"
              value={person.lastName || ''}
              onChange={e => onFieldChange(e.target.value, 'lastName')}
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group className="form-group">
        <Form.Label>Email</Form.Label>
        <input
          className="form-control"
          placeholder="Enter email"
          type="email"
          value={person.email || ''}
          onChange={e => onFieldChange(e.target.value, 'email')}
        />
      </Form.Group>

      <Form.Group className="form-group">
        <Form.Label>Phone</Form.Label>
        {person.phoneNumbers.filter(phoneNumber => !phoneNumber._destroy).map((phoneNumber) => {
          const phoneId = phoneNumber.id || phoneNumber.uuid;
          return (
            <Row className="row-eq-height align-items-end" key={phoneId}>
              <Col className="form-group" sm={6}>
                <input
                  className="form-control"
                  placeholder="Enter phone number"
                  type="tel"
                  value={advancedFormatPhoneNumber(phoneNumber.number) || ''}
                  onChange={e => onPhoneNumberChange(phoneId, parsePhoneNumber(e.target.value), 'number')}
                />
              </Col>
              <Col className="form-group" sm={3}>
                <select
                  className="form-control"
                  value={phoneNumber.label || ''}
                  onChange={e => onPhoneNumberChange(phoneId, e.target.value, 'label')}
                >
                  {PHONE_OPTIONS.map(phoneOption => (
                    <option key={phoneOption} value={phoneOption}>{phoneOption}</option>
                  ))}
                </select>
              </Col>
              <Col className="d-flex justify-content-around flex-nowrap" xs="auto">
                <Button.Secondary
                  plain
                  type="button"
                  onClick={() => onChangePhoneNumberPrimary(phoneId, !phoneNumber.primary)}
                >
                  <FontAwesomeIcon
                    className={phoneNumber.primary ? 'icon-gradient' : 'text-muted'}
                    icon={faStar}
                    size="lg"
                  />
                </Button.Secondary>
                <Button.Danger plain type="button" onClick={() => onDeletePhoneNumber(phoneId)}>
                  <FontAwesomeIcon className="text-danger" icon={faTrash} size="lg"/>
                </Button.Danger>
              </Col>
            </Row>
          );
        })}
      </Form.Group>

      <div className="form-group">
        <Button.Secondary icon={faPlus} plain type="button" onClick={onAddPhoneNumber}>
          Add Phone Number
        </Button.Secondary>
      </div>

      <Form.Group className="form-group">
        <Form.Label>Job Title</Form.Label>
        <input
          className="form-control"
          placeholder="Enter job title"
          type="text"
          value={person.jobTitle || ''}
          onChange={e => onFieldChange(e.target.value, 'jobTitle')}
        />
      </Form.Group>

      {showCompanyName && (
        <Form.Group className="form-group">
          <Form.Label>Company Name</Form.Label>
          <input
            className="form-control"
            placeholder="Enter company name"
            type="text"
            value={person.companyName || ''}
            onChange={e => onFieldChange(e.target.value, 'companyName')}
          />
        </Form.Group>
      )}
    </React.Fragment>
  );
}

PersonContactForm.propTypes = {
  accessibleDatabaseContacts: PropTypes.array,
  areFieldsRequired: PropTypes.bool.isRequired,
  displayName: PropTypes.string,
  person: PropTypes.object.isRequired,
  showCompanyName: PropTypes.bool,
  onAddPhoneNumber: PropTypes.func.isRequired,
  onChangePhoneNumberPrimary: PropTypes.func.isRequired,
  onDeletePhoneNumber: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onPhoneNumberChange: PropTypes.func.isRequired
};
